import { ExpandedPatient, RDVM } from '../utils/dataTypes';
import { pimsApi } from './pimsApi';

// Define a service using a base URL and expected endpoints
export const rdvmApi = pimsApi.injectEndpoints({
	endpoints: (builder) => ({
		searchRdvm: builder.query<RDVM[], number | null>({
			query: (visitId) => {
				const visitIdQuery = (visitId === null || visitId === undefined) ? "" : `?visit_id=${visitId}`
				return `rdvm/search${visitIdQuery}`
			},
			providesTags: () => [{ type: 'rDVM' }],
			transformResponse: (response: { data: RDVM[] }) => response.data,
		}),
		attachRdvmToPatient: builder.mutation<
			ExpandedPatient,
			{ clinic_id: string; pet_id: string }
		>({
			query({ clinic_id, pet_id }) {
				return {
					url: `rdvm/${clinic_id}/relationship`,
					method: 'PUT',
					body: { pet_id },
				};
			},
		}),
		setRdvmNote: builder.mutation<void, {id: string, note: string}>({
			query({ id, note }) {
				return {
					url: `rdvm/${id}/rdvm_note`,
					method: 'PUT',
					body: { note }
				}
			},
			invalidatesTags: () => [{ type: 'rDVM' }],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const {
	useSearchRdvmQuery,
	useAttachRdvmToPatientMutation,
	useSetRdvmNoteMutation
} = rdvmApi;
